import {IEmploymentStatus} from './employment-status.interface';
import {HelpConsts} from '../help/models/help-consts';
import {consts} from '../common/modals/consts';

export class EmploymentStatus implements IEmploymentStatus{
  constructor(iEmploymentStatus?: IEmploymentStatus) {
    this.id = iEmploymentStatus?.id || consts.emptyGuid;
    this.name = iEmploymentStatus?.name || '';
    this.description = iEmploymentStatus?.description || '';
    this.isDefault = iEmploymentStatus?.isDefault || false;
    this.isSelected = iEmploymentStatus?.isSelected || false;
  }
  id: string;
  name: string;
  description: string;
  isDefault: boolean;
  isSelected: boolean;
}
